const Form107EN = {
    stepName: {
        importantNotes: "Important Notes",
        partA: "Select the document(s) for submission",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
    },
    dialog: {
        message:
            "We acknowledge receipt of your application. It is now under processing.</br></br>Should you have any enquiries, please contact us at 3467-8275 or 2780-8145.",
        confirmRemoveTitle: "Application Form Removal",
        confirmRemoveContent:
            "You are about to <b>REMOVE</b> the uploaded application form. The application of this subject person will not be further processed. If you wish to <b>submit an updated application form</b>, please click <b>UPDATE</b> to upload the updated file instead.",
    },
    label: {
        typeHeader: "Submit Application Form(s)",
        attachmentTitle1: "Please submit the completed application form in <b>e-fillable PDF</b> format. Submission of a <u style='text-decoration : underline; text-decoration-skip-ink: none;'>scanned copy</u> or an image of the completed form will <u>NOT</u> be accepted.",
        attachmentTitle2: "College should upload the completed application form of each subject person according the order listed in the cover letter.",
        applicationPurpose: "Submit document(s)",
        uploadFiles: "Choose the file(s) to be submitted",
        confirmFile: "Confirm file(s)",
        schoolName: "School Name",
        coverLetter: "Cover Letter",
    },
    errorMsg: {
        pdfSignRequired: "Please sign the PDF.",
    },
    AttachmentInstruction1: "Acceptable file types: {{types}}",
    AttachmentInstruction2: "Maximum size of each file is {{size}}MB.",
    AttachmentInstruction3:
        "Maximum length of file name is {{length}} characters.",
    AttachmentInstruction4: `Please use the "Add" button to add more files (max. {{files}}) if needed.`,
};

export default Form107EN;
